import { InjectionToken } from "@angular/core";

export const DATA_TOKEN = new InjectionToken("DATA");
